import { jsx, jsxs } from 'react/jsx-runtime';
import styled from 'styled-components';
import { Button } from '../button/button.js';
import { Text } from '../text/text.js';
import { colors } from '../../tokens/colors/colors.js';
import { spacing } from '../../tokens/spacing/spacing.js';

function Banner({ type = "default", size = "medium", fullWidth = false, show = true, hideBorder, children, icon, title, buttons = [], horizontal, ...props }) {
    if (!show) {
        return null;
    }
    const AlertStyle = getAlertStyle(type);
    return (jsx(AlertStyle, { size: size, "$fullWidth": fullWidth, "$hideBorder": hideBorder, ...props, children: jsxs(ContentBox, { "$horizontal": horizontal, children: [icon && jsx(Icon, { "$horizontal": horizontal, children: icon }), title && (jsx(Text, { variant: "subtitle", color: "unset", children: title })), children && (jsx(Body, { "$horizontal": horizontal, children: jsx(Text, { variant: getTextVariant(size), color: "unset", children: children }) })), !!buttons.length && (jsx(Buttons, { "$horizontal": horizontal, children: buttons.map(({ label, onClick, buttonProps }) => (jsx(Button, { variant: "subtle", size: "small", onClick: onClick, ...buttonProps, children: label }, label))) }))] }) }));
}
const Icon = styled.div `
  ${({ $horizontal }) => $horizontal && "grid-row: span 2;"}
`;
const Body = styled.div `
  grid-column: ${({ $horizontal }) => (!$horizontal ? "span 2" : "2")};
`;
const Buttons = styled.div `
  display: flex;
  gap: ${spacing.S};
  flex-wrap: wrap;
  grid-column: ${({ $horizontal }) => (!$horizontal ? "span 2" : "2")};
  margin-top: ${({ $horizontal }) => ($horizontal ? spacing.S : "0")};
`;
const ContentBox = styled.div `
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: ${({ $horizontal }) => ($horizontal ? "center" : "start")};
  column-gap: ${spacing.XS};
  row-gap: ${({ $horizontal }) => (!$horizontal ? spacing.M : spacing.XS3)};
`;
function getAlertStyle(type) {
    switch (type) {
        case "good":
            return Good;
        case "info":
            return Info;
        case "warning":
            return Warning;
        case "error":
            return Error;
        case "neutral":
            return Neutral;
        default:
            return Default;
    }
}
function getTextVariant(size) {
    switch (size) {
        case "small":
            return "bodyS";
        default:
            return "body";
    }
}
const Base = styled.div `
  background: ${colors.neutral};
  ${({ size }) => {
    switch (size) {
        case "small":
            return `padding: 1px ${spacing.XS};`;
        case "medium":
            return `padding: ${spacing.M};`;
        default:
            return `padding: ${spacing.L};`;
    }
}}
  border-radius: ${(props) => (!props.$hideBorder ? "0.875rem" : "0")};
  display: ${(props) => (props.$fullWidth ? "block" : "inline-block")};
  flex-basis: ${(props) => (props.$fullWidth ? "100%" : "auto")};
`;
const Default = styled(Base) `
  background: inherit;
  border-color: ${colors.neutral};
  border-width: ${(props) => (!props.$hideBorder ? "1px" : "0px")};
  border-style: solid;
  color: inherit;
`;
const Neutral = styled(Base) `
  color: ${colors.textPrimary};
`;
const Good = styled(Base) `
  background: ${colors.systemGoodLight};
  color: ${colors.systemGoodDark};
`;
const Info = styled(Base) `
  background: ${colors.systemInfoLight};
  color: ${colors.systemInfoDark};
`;
const Warning = styled(Base) `
  background: ${colors.systemWarningLight};
  color: ${colors.systemWarningDark};
`;
const Error = styled(Base) `
  background: ${colors.systemErrorLight};
  color: ${colors.systemErrorDark};
`;

export { Banner };
